/**
 * Smoothly scrolls an element into view.
 *
 * @param {string|Element} target - the element, or a CSS selector for it
 * @param {Object} [options]
 * @param {number} [options.offset=0] - px to stop short of the element's top
 * @param {ScrollBehavior} [options.behavior='smooth'] - 'auto' to jump
 * @returns {boolean} - true if the element was found and scrolled to
 */
export const scrollTo = (target, {
  offset = 0,
  behavior = 'smooth'
} = {}) => {
  const element = typeof target === 'string' ? document.querySelector(target) : target;
  if (!element) {
    return false;
  }
  const top = element.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({
    top: Math.max(0, top),
    behavior
  });
  return true;
};

/** Every "go to the form" CTA on the booking page lands on the form title. */
export const scrollToForm = () => scrollTo('.appointment-form__title', {
  offset: 10
});